import * as THREE from 'three'

export type FighterScaleBaseline={object:THREE.Object3D;scale:THREE.Vector3}
export type FighterDeformationBaseline={entries:FighterScaleBaseline[];repairs:number;checks:number}

const finite=(v:number)=>Number.isFinite(v)
const median3=(a:number,b:number,c:number)=>[a,b,c].sort((x,y)=>x-y)[1]

export function captureFighterDeformationBaseline(root:THREE.Object3D,authoredScales?:ReadonlyMap<string,THREE.Vector3>):FighterDeformationBaseline{
 const entries:FighterScaleBaseline[]=[]
 root.traverse(object=>{
  if(object===root||(object as THREE.Bone).isBone||object instanceof THREE.Mesh)
   entries.push({object,scale:((object as THREE.Bone).isBone?authoredScales?.get(object.name.toLowerCase()):undefined)?.clone()??object.scale.clone()})
 })
 return{entries,repairs:0,checks:0}
}

export function enforceFighterDeformationBaseline(
 baseline:FighterDeformationBaseline,
 anisotropyLimit=1.035,
 minUniformRatio=.72,
 maxUniformRatio=1.28,
){
 let repaired=0
 for(const entry of baseline.entries){
  const base=entry.scale,current=entry.object.scale
  const rx=Math.abs(base.x)>1e-8?current.x/base.x:1
  const ry=Math.abs(base.y)>1e-8?current.y/base.y:1
  const rz=Math.abs(base.z)>1e-8?current.z/base.z:1
  const ratios=[rx,ry,rz]
  const valid=ratios.every(v=>finite(v)&&v>1e-6)
  const min=valid?Math.min(...ratios):0,max=valid?Math.max(...ratios):Infinity
  const anisotropy=valid&&min>1e-8?max/min:Infinity
  if(valid&&anisotropy<=anisotropyLimit&&min>=minUniformRatio&&max<=maxUniformRatio)continue
  const uniform=valid?THREE.MathUtils.clamp(median3(rx,ry,rz),minUniformRatio,maxUniformRatio):1
  current.set(base.x*uniform,base.y*uniform,base.z*uniform)
  entry.object.updateMatrix()
  repaired++
 }
 baseline.checks++
 baseline.repairs+=repaired
 return repaired
}

export function deformationGuardReport(baseline:FighterDeformationBaseline){
 return{tracked:baseline.entries.length,checks:baseline.checks,repairs:baseline.repairs}
}
